/**
 * Хранение операторского токена.
 *
 * Токен передаётся в UI один раз через ?token=… в адресе страницы, немедленно
 * сохраняется в localStorage и вычищается из адресной строки. Оставлять его в
 * URL нельзя: каждая загрузка страницы с query-параметром пишет секрет в
 * access-лог nginx, историю браузера и любую скопированную ссылку.
 */

const STORAGE_KEY = "pm_scalper_operator_token";

function consumeTokenFromURL(): void {
  const params = new URLSearchParams(location.search);
  const token = params.get("token");
  if (!token) return;

  try {
    localStorage.setItem(STORAGE_KEY, token);
  } catch {
    // Хранилище недоступно (приватный режим со странными настройками) —
    // токен доживёт до перезагрузки в памяти модуля через fallback ниже.
    inMemoryToken = token;
  }
  params.delete("token");
  const query = params.toString();
  history.replaceState(null, "", location.pathname + (query ? `?${query}` : "") + location.hash);
}

let inMemoryToken: string | null = null;

consumeTokenFromURL();

/** Текущий токен оператора или null в открытом режиме. */
export function getToken(): string | null {
  if (inMemoryToken) return inMemoryToken;
  try {
    return localStorage.getItem(STORAGE_KEY);
  } catch {
    // Хранилище недоступно целиком (политика «блокировать все куки» и т.п.) —
    // работаем как в открытом режиме, а не роняем интерфейс.
    return null;
  }
}
